import script from "./SideModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SideModal.vue?vue&type=script&setup=true&lang=js"

import "./SideModal.vue?vue&type=style&index=0&id=9c383702&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c383702"]])

export default __exports__